var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "#FEFCE8",
    stroke: "#A16207"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16V21H16.5815M31.9381 23C31.446 19.0537 28.0796 16 24 16C20.6426 16 17.7683 18.0682 16.5815 21M16.5815 21H21M32 32V27H31.4185M31.4185 27C30.2317 29.9318 27.3574 32 24 32C19.9204 32 16.554 28.9463 16.0619 25M31.4185 27H27",
    stroke: "#A16207",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleIcon);
export default __webpack_public_path__ + "static/media/schedule-icon.4c6d6fd07a38bba7e4e1009af2b6d110.svg";
export { ForwardRef as ReactComponent };